import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateReimbursementMethod } from '../../../../../actions';

const useCareCreditCardSubmit = () => {
  const store = useSelector(({
    billingPayments,
  }) => ({ billingPayments }), shallowEqual);
  const {
    billingPayments: {
      reimbursementData,
    },
    billingPayments,
  } = store;
  const dispatch = useDispatch();

  const loading = billingPayments.updatingReimbursementMethod;
  const updateSuccess = billingPayments.reimbursementMethodUpdateSuccess
    && !billingPayments.updatingReimbursementMethod;

  const onSubmitCareCredit = useCallback(() => {
    if (reimbursementData.updatingReimbursementMethod) {
      return;
    }

    dispatch(updateReimbursementMethod(reimbursementData));
  }, [reimbursementData, dispatch]);

  return {
    loading,
    onSubmitCareCredit,
    updateSuccess,
  };
};

export { useCareCreditCardSubmit };
